import React from "react"
import {
   LineStyle,
   Timeline,
   TrendingUp,
   PermIdentity,
   Storefront,
   AttachMoney,
   BarChart,
   MailOutline,
   DynamicFeed,
   ChatBubbleOutline,
   WorkOutline,
   Report,
   FavoriteBorder,
   Redeem,
   MenuBook,
   AddAPhoto,
   BuildOutlined,
} from "@material-ui/icons"
// Styles
import {
   Container,
   Icons,
   List,
   ListItem,
   Menu,
   StyledLink,
   Title,
   Wrapper,
} from "./Sidebar.styles"

const Sidebar = () => {
   return (
      <Container>
         <Wrapper>
            <Menu>
               <Title>Dashboards</Title>
               <List>
                  <ListItem>
                     <StyledLink to="/">
                        <Icons>
                           <LineStyle color="secondary" />
                        </Icons>
                        Home
                     </StyledLink>
                  </ListItem>
                  <ListItem>
                     <Icons>
                        <Timeline color="secondary" />
                     </Icons>
                     Analytics
                  </ListItem>
                  <ListItem>
                     <Icons>
                        <TrendingUp color="secondary" />
                     </Icons>
                     Sales
                  </ListItem>
               </List>
            </Menu>
            <Menu>
               <Title>Quick Menu</Title>
               <List>
                  <ListItem>
                     <StyledLink to="/users">
                        <Icons>
                           <PermIdentity color="secondary" />
                        </Icons>
                        Users
                     </StyledLink>
                  </ListItem>
                  <ListItem>
                     <StyledLink to="/products">
                        <Icons>
                           <Redeem color="secondary" />
                        </Icons>
                        Products
                     </StyledLink>
                  </ListItem>
                  <ListItem>
                     <StyledLink to="/orders">
                        <Icons>
                           <AttachMoney color="secondary" />
                        </Icons>
                        Orders
                     </StyledLink>
                  </ListItem>
                  <ListItem>
                     <StyledLink to="/favorites">
                        <Icons>
                           <FavoriteBorder color="secondary" />
                        </Icons>
                        Favorites
                     </StyledLink>
                  </ListItem>
                  <ListItem>
                     <StyledLink to="/shops">
                        <Icons>
                           <Storefront color="secondary" />
                        </Icons>
                        Shops
                     </StyledLink>
                  </ListItem>
                  <ListItem>
                     <StyledLink to="/page-contents">
                        <Icons>
                           <MenuBook color="secondary" />
                        </Icons>
                        Page Contents
                     </StyledLink>
                  </ListItem>
                  <ListItem>
                     <StyledLink to="/images">
                        <Icons>
                           <AddAPhoto color="secondary" />
                        </Icons>
                        Pictures
                     </StyledLink>
                  </ListItem>
                  <ListItem>
                     <StyledLink to="/emails">
                        <Icons>
                           <MailOutline color="secondary" />
                        </Icons>
                        Emails
                     </StyledLink>
                  </ListItem>
                  <ListItem>
                     <StyledLink to="/services">
                        <Icons>
                           <BuildOutlined color="secondary" />
                        </Icons>
                        SAV
                     </StyledLink>
                  </ListItem>
               </List>
            </Menu>
            <Menu>
               <Title>Notifications</Title>
               <List>
                  <ListItem>
                     <Icons>
                        <MailOutline color="secondary" />
                     </Icons>
                     Mail
                  </ListItem>
                  <ListItem>
                     <Icons>
                        <DynamicFeed color="secondary" />
                     </Icons>
                     Feedback
                  </ListItem>
                  <ListItem>
                     <Icons>
                        <ChatBubbleOutline color="secondary" />
                     </Icons>
                     Messages
                  </ListItem>
               </List>
            </Menu>
            <Menu>
               <Title>Staff</Title>
               <List>
                  <ListItem>
                     <Icons>
                        <WorkOutline color="secondary" />
                     </Icons>
                     Manage
                  </ListItem>
                  <ListItem>
                     <Icons>
                        <BarChart color="secondary" />
                     </Icons>
                     Analytics
                  </ListItem>
                  <ListItem>
                     <Icons>
                        <Report color="secondary" />
                     </Icons>
                     Reports
                  </ListItem>
               </List>
            </Menu>
         </Wrapper>
      </Container>
   )
}

export default Sidebar
